import React from 'react';

import {
  Labeled,
  maxValue,
  minValue,
  NumberInput,
  required,
  TextInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import CreateDialog from '../layout/dialog/CreateDialog';
import InfoPopover from '../layout/InfoPopover';

import RiskClassInput from '../../customFields/RiskClassInput';

const GroupCreate = () => (
  <CreateDialog title="group">
    <Grid container spacing={6}>
      <Grid size={12}>
        <Labeled label="Name">
          <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
        </Labeled>
      </Grid>
      <Grid size={12}>
        <Labeled
          label={(
            <>
              Default risk (%)
              <InfoPopover title="Default risk" content="Probability of financial crime activity given which entity is in that group." />
            </>
          )}
        >
          <NumberInput fullWidth validate={[required(), maxValue(99), minValue(0)]} source="score" label="" helperText={false} />
        </Labeled>
      </Grid>
      <Grid size={12}>
        <Labeled
          label={(
            <>
              Corresponding risk class
              <InfoPopover title="Corresponding risk classes" content="The risk class corresponding to the default risk chosen." />
            </>
          )}
        >
          <RiskClassInput source="score" />
        </Labeled>
      </Grid>
    </Grid>
  </CreateDialog>

);

export default GroupCreate;
